enum DelegationListingDelegationStatus {
  UNDOWNLOADED = "UNDOWNLOADED",
  DOWNLOADED = "DOWNLOADED",
  DELETED = "DELETED",
}

export default DelegationListingDelegationStatus;
